<template>
  <section class="container-fluid py-6 py-md-8">
    <div class="row justify-content-center">
      <div class="col-12 col-md-10 col-lg-8 col-xl-7 text-center">
        <h1 class="mb-4">Our Team</h1>
        <hr />
        <p class="mb-6">
          Our partners are highly experienced Wall Street executives who have
          worked together as a dedicated team over the vast majority of their
          careers spanning over two decades.
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-8 col-lg-6 offset-lg-3 col-xl-6">
        <div class="team-container d-flex">
          <img src="@/assets/plus-icon.png" class="toggle-icon" />
          <div class="bio-text">
            <h4>David Caleca</h4>
            <h5 data-v-1491fe38>Managing Director</h5>
            <div class="team-description">
              <p>
                David Caleca, a co-founder of the firm, is responsible for
                overseeing new corporate advisory business development
                activities and the execution of transactions. David has over
                twenty years of investment banking and financial advisory
                experience. Since 1996, he has worked on a wide range of
                mergers, acquisitions, capital market, restructuring, and
                recapitalization transactions primarily for senior housing,
                hospitality, REITs and real estate related companies.
              </p>
              <p>
                In 1999, David and his partners co-founded CSCA in conjunction
                with Cohen & Steers, Inc. From July 1997 to February 1999, Mr.
                Caleca was an Analyst with the Corporate Finance Department at
                Schroder & Co. Inc. Mr. Caleca began his career in the
                Investment Banking Department of NatWest Markets.
              </p>
              <p>
                Mr. Caleca is a Phi Beta Kappa graduate of the College of Arts &
                Sciences at Cornell University with a Bachelor of Arts degree in
                Economics. He also holds a General Course Economics degree from
                the London School of Economics. He actively serves on the
                National Investment Center for Seniors Housing & Care (NIC) Data
                and Analytics Committee.
              </p>
            </div>
          </div>
        </div>
        <div class="team-container d-flex">
          <img src="@/assets/plus-icon.png" class="toggle-icon" />
          <div class="bio-text">
            <h4>Laurent X. de Marval</h4>
            <h5 data-v-1491fe38>Managing Director</h5>
            <div class="team-description">
              <p>
                Laurent de Marval, a co-founder of the firm, is responsible for
                new corporate advisory business development activities and the
                execution of transactions. Mr. de Marval has over thirty years
                of investment banking experience and has been actively involved
                in the healthcare REIT, skilled nursing and senior housing
                industries since the early 1990’s. Mr. de Marval has been
                involved in many of the industry’s formative transactions
                including numerous initial public offerings, mergers and
                acquisitions, capital raising, recapitalizations and
                restructurings. From 1997 to 1999, Mr. de Marval was a Managing
                Director with the Corporate Finance Department at Wertheim
                Schroder & Co. Inc. Prior to 1997, he was a Senior Director in
                the Investment Banking Department at NatWest Markets.
              </p>
              <p>
                Laurent is a graduate of the School of Business at the
                University of Connecticut and is a Swiss citizen.
              </p>
            </div>
          </div>
        </div>
        <div class="team-container d-flex">
          <img src="@/assets/plus-icon.png" class="toggle-icon" />
          <div class="bio-text">
            <h4>Christopher Falkowski</h4>
            <h5 data-v-1491fe38>Managing Director</h5>
            <div class="team-description">
              <p>
                Christopher Falkowski is currently a Managing Director and
                partner at the firm. Chris has extensive experience investing in
                and managing senior housing investments, both as an advisor and
                a principal. Previously, Chris was at Fortress Investment Group,
                a diversified private equity firm, where he managed Fortress’
                senior housing holdings, including its $7 billion investment in
                Holiday Retirement. During his time at Fortress, Chris led
                approximately $3 billion of real estate transactions across a
                range of healthcare real estate asset classes. In addition,
                Chris served as CEO and director for a sponsor-backed startup
                property management company focused on senior housing
                properties, with clients including a publicly traded healthcare
                REIT. Chris began his professional career with CS Capital
                Advisors while it was affiliated with Cohen & Steers.
              </p>
              <p>
                He has a B.S. in Finance from the Stern School of Business at
                New York University.
              </p>
            </div>
          </div>
        </div>
        <div class="team-container d-flex">
          <img src="@/assets/plus-icon.png" class="toggle-icon" />
          <div class="bio-text">
            <h4>Peter E. Pickette</h4>
            <h5 data-v-1491fe38>Managing Director</h5>
            <div class="team-description">
              <p>
                Peter Pickette has over 25 years of experience providing
                financial advisory services to his clients. Over that time
                period, Peter has advised on many of the transactions that have
                transformed the senior housing and healthcare real estate
                related sectors. Peter is responsible for generating new
                financial advisory and asset management business. He has worked
                on over $70 billion of merger and acquisition, recapitalization
                and restructuring transactions primarily for healthcare service,
                REITs, and real estate related companies.
              </p>
              <p>
                March of 1999, Peter and his partners co-founded CSCA in
                conjunction with Cohen & Steers, Inc. to provide high quality
                value-added financial advisory services to healthcare companies
                and other companies with significant real estate assets. From
                July 1997 to February 1999, Peter was a Vice President with the
                Corporate Finance Department at Schroder & Co. Inc. focused on
                M&A and capital raising for REITs and healthcare related
                companies. Mr. Pickette began his investment banking career in
                1993 at NatWest Markets, the investment banking subsidiary of
                National Westminster Bank plc.
              </p>
              <p>
                Peter received a Bachelor of Science in Finance from the Wallace
                E. Carroll School of Management at Boston College. He is a
                member of the Executive Board of the American Senior Housing
                Association. Peter is married with two children.
              </p>
            </div>
          </div>
        </div>
        <div class="team-container d-flex">
          <img src="@/assets/plus-icon.png" class="toggle-icon" />
          <div class="bio-text">
            <h4>Bradley G. Razook</h4>
            <h5 data-v-1491fe38>Managing Director</h5>
            <div class="team-description">
              <p>
                Bradley G. Razook, a co-founder of the firm, is responsible for
                overseeing and executing corporate finance activities. From July
                of 1997 to March 1999, Mr. Razook was Managing Director and Head
                of Healthcare Investment Banking at Schroder & Co. Inc. Prior to
                joining Schroder & Co., Mr. Razook was Executive Vice President
                and Head of Investment Banking at NatWest Markets, the U.S.
                investment banking arm of National Westminster Bank PLC. From
                March 1985 to March 1990 Mr. Razook was First Vice President and
                Counsel of Drexel Burnham Lambert Incorporated. Mr. Razook
                previously served as a Director and member of the Executive
                Committee of the National Investment Center for Seniors Housing
                and Care (“NIC”) (2010-2018) and as Chairman of the Board of
                Directors of NIC (2017-2018).
              </p>
              <p>
                Mr. Razook received a JD from New York Law School, a BA from
                Tufts University, and is a graduate of The Choate School. From
                1977-1979 he was a contributing editor of National Lampoon
                Magazine where he authored a monthly piece entitled 'Lives of
                the Great'.
              </p>
            </div>
          </div>
        </div>

        <div class="team-container d-flex">
          <img src="@/assets/plus-icon.png" class="toggle-icon" />
          <div class="bio-text">
            <h4>Paul Vorderis</h4>
            <h5 data-v-1491fe38>Managing Director</h5>
            <div class="team-description">
              <p>
                Paul Vorderis is a Managing Director and partner of CS Capital
                Advisors and is responsible for the origination and execution of
                transactions in the real estate and healthcare services sectors.
                Since joining the team in 2007, Paul has structured and
                successfully executed over $25 billion of transactions including
                mergers, acquisitions, dispositions, recapitalizations and
                restructurings involving REITs, private equity investors and
                operating companies.
              </p>
              <p>
                Paul was a member of the team during the establishment of CS
                Capital Advisors, LLC in 2009. Prior to 2009, Paul was an
                investment banker at Cohen & Steers Capital Advisors, LLC while
                the firm was an affiliate of Cohen & Steers, Inc. Before joining
                Cohen & Steers, Inc., Paul worked at Bracebridge Capital, LLC, a
                hedge fund sponsor based in Boston, MA.
              </p>
              <p>
                Paul is a graduate of Stonehill College where he earned a B.S.
                in Business Administration with a Major in Finance and Minor in
                Economics.
              </p>
            </div>
          </div>
        </div>

        <!-- <BioCard
        v-for="member in team"
        :key="member.id"
        :name="member.name"
        :title="member.title"
        :bio="member.bio"
        />-->
      </div>
    </div>
  </section>
</template>

<script>
export default {
  methods: {
    openDescription() {
      var teamContainers = document.querySelectorAll(".team-container");
      for (var i = 0; i < teamContainers.length; i++) {
        teamContainers[i].addEventListener("click", function() {
          this.classList.toggle("open-description");
        });
      }
    }
  },
  mounted() {
    this.openDescription();
  },
  data() {
    return {
      team: [
        {
          id: "1",
          name: "Peter E. Pickette",
          title: "Managing Director",
          bio:
            "Peter Pickette has over 25 years of experience providing financial advisory services to his clients.  Over that time period, Peter has advised on many of the transactions that have transformed the senior housing and healthcare real estate related sectors.  Peter is responsible for generating new financial advisory and asset management business. He has worked on over $70 billion of merger and acquisition, recapitalization and restructuring transactions primarily for healthcare service, REITs, and real estate related companies. In March of 1999, Peter and his partners co-founded CSCA in conjunction with Cohen & Steers, Inc. to provide high quality value-added financial advisory services to healthcare companies and other companies with significant real estate assets. From July 1997 to February 1999, Peter was a Vice President with the Corporate Finance Department at Schroder & Co. Inc. focused on M&A and capital raising for REITs and healthcare related companies. Mr. Pickette began his investment banking career in 1993 at NatWest Markets, the investment banking subsidiary of National Westminster Bank plc. Peter received a Bachelor of Science in Finance from the Wallace E. Carroll School of Management at Boston College.  He is a member of the Executive Board of the American Senior Housing Association.  Peter is married with two children."
        },
        {
          id: "2",
          name: "Christopher Falkowski",
          title: "Managing Director",
          bio:
            "Christopher Falkowski is currently a Managing Director and partner at the firm. Chris has extensive experience investing in and managing seniors housing investments, both as an advisor and a principal.  Previously, Chris was at Fortress Investment Group, a diversified private equity firm, where he managed Fortress’ seniors housing holdings, including its $7 billion investment in Holiday Retirement. During his time at Fortress, Chris led approximately $3 billion of real estate transactions across a range of healthcare real estate asset classes.  In addition, Chris served as CEO and director for a sponsor-backed startup property management company focused on seniors housing properties, with clients including a publicly traded healthcare REIT.  Chris began his professional career with CS Capital Advisors while it was affiliated with Cohen & Steers. He has a B.S. in Finance from the Stern School of Business at New York University."
        },
        {
          id: "3",
          name: "Paul Vorderis",
          title: "Managing Director",
          bio:
            "Paul Vorderis is a Managing Director and partner of CS Capital Advisors and is responsible for the origination and execution of transactions in the real estate and healthcare services sectors. Since joining the team in 2007, Paul has structured and successfully executed over $25 billion of transactions including mergers, acquisitions, dispositions, recapitalizations and restructurings involving REITs, private equity investors and operating companies. Paul was a member of the team during the establishment of CS Capital Advisors, LLC in 2009. Prior to 2009, Paul was an investment banker at Cohen & Steers Capital Advisors, LLC while the firm was an affiliate of Cohen & Steers, Inc. Before joining Cohen & Steers, Inc., Paul worked at Bracebridge Capital, LLC, a hedge fund sponsor based in Boston, MA. Paul is a graduate of Stonehill College where he earned a B.S. in Business Administration with a Major in Finance and Minor in Economics."
        },
        {
          id: "4",
          name: "David Caleca",
          title: "Managing Director",
          bio:
            "David Caleca, a co-founder of the firm, is responsible for overseeing new corporate advisory business development activities and the execution of transactions. David has over twenty years of investment banking and financial advisory experience.  Since 1996, he has worked on a wide range of mergers, acquisitions, capital market, restructuring, and recapitalization transactions primarily for seniors housing, hospitality, REITs and real estate related companies. In 1999, David and his partners co-founded CSCA in conjunction with Cohen & Steers, Inc. From July 1997 to February 1999, Mr. Caleca was an Analyst with the Corporate Finance Department at Schroder & Co. Inc. Mr. Caleca began his career in the Investment Banking Department of NatWest Markets. Mr. Caleca is a Phi Beta Kappa graduate of the College of Arts & Sciences at Cornell University with a Bachelor of Arts degree in Economics. He also holds a General Course Economics degree from the London School of Economics.  He actively serves on the National Investment Center for Seniors Housing & Care (NIC) Data and Analytics Committee."
        },
        {
          id: "5",
          name: "Bradley G. Razook",
          title: "Managing Director",
          bio:
            "Bradley G. Razook, a co-founder of the firm, is responsible for overseeing and executing corporate finance activities. From July of 1997 to March 1999, Mr. Razook was Managing Director and Head of Healthcare Investment Banking at Schroder & Co. Inc. Prior to joining Schroder & Co., Mr. Razook was Executive Vice President and Head of Investment Banking at NatWest Markets, the U.S. investment banking arm of National Westminster Bank PLC. From March 1985 to March 1990 Mr. Razook was First Vice President and Counsel of Drexel Burnham Lambert Incorporated. Mr. Razook previously served as a Director and member of the Executive Committee of the National Investment Center for Seniors Housing and Care (“NIC”) (2010-2018) and as Chairman of the Board of Directors of NIC (2017-2018). Mr. Razook received a JD from New York Law School, a BA from Tufts University, and is a graduate of The Choate School. From 1977-1979 he was a contributing editor of National Lampoon Magazine where he authored a monthly piece entitled 'Lives of the Great'."
        },
        {
          id: "6",
          name: "Laurent X. de Marval",
          title: "Managing Director",
          bio:
            "Laurent de Marval, a co-founder of the firm, is responsible for new corporate advisory business development activities and the execution of transactions.  Mr. de Marval has over thirty years of investment banking experience and has been actively involved in the healthcare REIT, skilled nursing and seniors housing industries since the early 1990’s.  Mr. de Marval has been involved in many of the industry’s formative transactions including numerous initial public offerings, mergers and acquisitions, capital raising, recapitalizations and restructurings. From 1997 to 1999, Mr. de Marval was a Managing Director with the Corporate Finance Department at Wertheim Schroder & Co. Inc.  Prior to 1997, he was a Senior Director in the Investment Banking Department at NatWest Markets. Laurent is a graduate of the School of Business at the University of Connecticut and is a Swiss citizen.  "
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
p {
  line-height: 1.65rem;
  @media screen and (max-width: 768px) {
    line-height: 1.65rem;
  }
}
hr {
  width: 100px;
  margin: 1rem auto;
}
.team-container {
  cursor: pointer;
  margin-bottom: 1.25rem;
  border-bottom: 1px solid #fafafa;
  padding-bottom: 1.25rem;
}
.team-description {
  overflow: hidden;
  opacity: 0;
  height: 0;
  transition: opacity 0.5s ease;
}
.toggle-icon {
  height: 30px;
  width: 30px;
  max-width: 30px;
  margin-right: 30px;
  margin-top: 16px;
  transition: all 0.3s ease;
  display: block;
}
.open-description {
  .team-description {
    opacity: 1;
    height: auto;
  }
  .toggle-icon {
    transform: rotate(90deg);
  }
}
</style>
